"use client";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { MutableRefObject } from "react";
import { ProductDetailsResponse } from "@/types/product";
import { ProductCardUI } from "../product-card/product-card-ui";

interface Props {
  data: ProductDetailsResponse[];
  sliderRef: MutableRefObject<Slider | null>;
}

export default ({ data, sliderRef }: Props) => {
  const settings = {
    arrows: false,
    infinite: data.length > 3,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <Slider
      className="container mx-auto p-4 md:pr-0 product-cards-equal-height"
      ref={sliderRef}
      {...settings}
    >
      {data.map((product) => (
        <div className="flex flex-col px-1 h-full" key={product.id}>
          <ProductCardUI
            product={product}
            pageType="products"
          />
        </div>
      ))}
    </Slider>
  );
};
